import TextInput from "components/FormElements/TextInput";
import React, { Fragment } from "react";

export default function CallWebhookAction(props) {
    return (
        <Fragment>
            <TextInput
                label="URL"
                name={`actions[${props.index}].properties.url`}
            />
            <div className="text-xs text-gray-800">
                See{" "}
                <a
                    href="https://docs.getsnworks.com/front-end/connector-api/#example"
                    target="_blank"
                    rel="nofollow, noreferrer"
                    className="text-green-600 underline"
                >
                    CEO API documentation
                </a>{" "}
                for more information on webhook data.
            </div>
        </Fragment>
    );
}
